export default __webpack_public_path__ + "static/media/discover-mleoha.c600d5b7.png";